import { Classbook } from './classbook.model';
import { ClassbookInterface } from './classbook.interface';

export class ClassbookFactory {

    static empty(): Classbook {
        return new Classbook('', undefined, undefined, [], new Date(), undefined, undefined, undefined, false);
    }

    static fromObject(raw: ClassbookInterface | any): Classbook {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Classbook(
            raw.id,
            raw.comment,
            raw.group,
            raw.parents,
            raw.sendDate && raw.sendDate._seconds ? new Date(raw.sendDate._seconds * 1000) : raw.sendDate,
            raw.student,
            raw.teacher,
            raw.approve && raw.approve.date._seconds ? {
                date: new Date(raw.approve.date._seconds * 1000),
                parent: raw.approve.parent,
                text: raw.approve.text,
            } : raw.approve,
            raw.isApproved,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/classbook/shared/classbook.factory.ts